module.exports = __webpack_public_path__ + "calculator-light-bg.1ab16d958c098ed055509ce9109fb354.svg";